import { documentsConstants } from '../../_constants';

export function SQdocuments(state = {}, action) {
    let newDoc = state.sqDocuments ? state.sqDocuments.documents : null;
    let newCharge = state.sqDocuments ? state.sqDocuments.charges : null;
    let newTermsAndConditions = state.sqDocuments ? state.sqDocuments.termsAndConditions : null;

    switch (action.type) {
        case documentsConstants.CLEAR_ALL_SQ_DOCUMENTS:
            return {
                customerDetails: null,
                sqDocuments: null
            };
        case documentsConstants.CREATE_SQ_DOCUMENT:
            return {
                ...state,
                sqDocuments: action.document
            };
        case documentsConstants.SAVE_CUSTOMER_DETAILS:
            return {
                ...state,
                customerDetails: action.customer
            };
        case documentsConstants.DELETE_SQ_DOCUMENT:
            let finalDoc = newDoc.filter(doc => {
                return action.id !== doc.sQDocNum
            });
            let finalCharge = newCharge.filter(charge => {
                return action.id !== charge.sQDocNum
            });
            let finalTerms = newTermsAndConditions.filter(terms => {
                return action.id !== terms.sQDocNum
            });

            var newSqDocuments = {};
            if (finalDoc.length > 0 && finalCharge.length > 0 && finalTerms.length > 0) {
                newSqDocuments.documents = finalDoc;
                newSqDocuments.charges = finalCharge;
                newSqDocuments.termsAndConditions = finalTerms;
            } else {
                newSqDocuments = null;
            }

            return {
                ...state,
                sqDocuments: newSqDocuments
            };
        case documentsConstants.GET_BY_SQ_DOC_NUM:
            if (newDoc || newCharge || newTermsAndConditions) {
                let selectedFinalDoc = newDoc.filter(doc => {
                    return action.id === doc.sQDocNum
                });
                let selectedFinalCharge = newCharge.filter(charge => {
                    return action.id === charge.sQDocNum
                });
                let selectedFinalTerms = newTermsAndConditions.filter(terms => {
                    return action.id === terms.sQDocNum
                });

                var newSelectedSqDocuments = {};
                newSelectedSqDocuments.documents = selectedFinalDoc;
                newSelectedSqDocuments.charges = selectedFinalCharge;
                newSelectedSqDocuments.termsAndConditions = selectedFinalTerms;

                return {
                    ...state,
                    selectedSQdocument: newSelectedSqDocuments
                };
            } else {
                return state;
            }
        default:
            return state;
    }
}